import Vue from "vue";
import App from "./App.vue";
// import '../plugins/element.js'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import "font-awesome/css/font-awesome.min.css";
// import axios from 'axios'
import router from "./router";
import service from "./service";
import store from "@/store";
import echarts from "echarts";
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, { ak: "JcqunMso5B90cLGRltRU8Ffsu040ktVN" });

Vue.use(ElementUI);
// Vue.prototype.axios = axios
Vue.prototype.service = service;
// Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
